export default __webpack_public_path__ + "static/week2-ac72a0e483edd90bf1a953aeae251fc9.png";